import { useContext } from "react";
import { AuthContext } from "../context/context.authentication";

export function useCurrentUser() {
  const { auth } = useContext(AuthContext);
  if (!auth.ok) {
    throw new Error("The content requested needs authentication.");
  }
  return auth.sub;
}
